import { render, staticRenderFns } from "./exchange-scheme-add.vue?vue&type=template&id=f4140f4e&scoped=true&"
import script from "./exchange-scheme-add.vue?vue&type=script&lang=js&"
export * from "./exchange-scheme-add.vue?vue&type=script&lang=js&"
import style0 from "./exchange-scheme-add.vue?vue&type=style&index=0&id=f4140f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4140f4e",
  null
  
)

export default component.exports